export const isEmbeddedMeetingPanelPath = (pathname?: string) => {
  const currentPathname = pathname ?? (typeof window !== 'undefined' ? window.location.pathname : '');
  return /^\/meetings\/[^/]+\/(questions-panel|messages-panel|inspire-panel|wisefriend-controls)\/?$/.test(currentPathname);
};
